
export default defineNuxtRouteMiddleware((to) => {
	let desired_lang = to.query._storyblok_lang
	if (desired_lang === undefined) {
	 	return
	}
	const { 'sec-fetch-dest': dest } = useRequestHeaders(['sec-fetch-dest'])
	const is_iframe = dest === 'iframe' || dest === 'frame'
	if (!is_iframe) {
		return
	}

	desired_lang = desired_lang.replace("default", "en")
	const { $i18n } = useNuxtApp()
	const current_lang = $i18n.locale.value.replace("de", "de_CH")

	if (desired_lang != current_lang) {
		console.info('storyblok lang mismatch!')
		const getRouteBaseName = useRouteBaseName()
		const localeRoute = useLocaleRoute()

		  // i18n suffixes route names (`slug___de`), so strip it before resolving.
		const name = getRouteBaseName(to)
		if (!name) {
			return
		}
		const target = localeRoute(
		    { name, params: to.params, query: to.query, hash: to.hash },
		    desired_lang,
		 )

		if (!target || target.path === to.path) {
			return
		}
		console.error(target)
   		return navigateTo(target, { replace: true, redirectCode: 302 })
	}
})
